module.exports = __webpack_public_path__ + "img/Warning.017eb94e.svg";